import { MUTATION_UPDATE_USER } from '@/graphql/mutations/user/update-user';
import {
  OnBoardingPage,
  OnBoardingPageQuery,
  OnBoardingStep1Query,
  OnBoardingStep2Query,
  OnBoardingStep3Query,
  OnBoardingStep4Query,
  OnBoardingStep5Query,
  UpdateUserProfileMutation,
  UpdateUsersPermissionsUserMutation,
} from '../../graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';

import requestHandler from '../requestHandler';
import { MUTATION_ONBOARDING_UPDATE_USER, QUERY_ONBOARDING_STEP3 } from '@/graphql/queries/on-boarding/step-3';
import { QUERY_ONBOARDING_STEP5 } from '@/graphql/queries/on-boarding/step-5';
import { QUERY_ONBOARDING_STEP4 } from '@/graphql/queries/on-boarding/step-4';
import { QUERY_ONBOARDING_STEP2 } from '@/graphql/queries/on-boarding/step-2';
import { QUERY_ONBOARDING_STEP1 } from '@/graphql/queries/on-boarding/step-1';
import { QUERY_ONBOARDING } from '@/graphql/queries/on-boarding/on-boarding';
import { MUTATION_UPDATE_USER_WEEKLY } from '@/graphql/mutations/on-boarding/user';

export const getPage = async () => {
  const apolloClient = initializeApollo();
  const { data, error } = await requestHandler(
    apolloClient.query<OnBoardingPageQuery>({
      query: QUERY_ONBOARDING,
    }),
  );

  return {
    page: data?.onBoardingPage?.data?.attributes as OnBoardingPage,
    error,
  };
};

export async function fetchOnBoardingStep1() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep1Query>({
      query: QUERY_ONBOARDING_STEP1,
    }),
  );

  return data?.step1?.data?.attributes;
}

export async function fetchOnBoardingStep2() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep2Query>({
      query: QUERY_ONBOARDING_STEP2,
    }),
  );

  return data?.step2?.data?.attributes;
}

export async function fetchOnBoardingStep3() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep3Query>({
      query: QUERY_ONBOARDING_STEP3,
    }),
  );

  return data?.step3?.data?.attributes;
}

export async function fetchOnBoardingStep4() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep4Query>({
      query: QUERY_ONBOARDING_STEP4,
    }),
  );

  return data?.step4?.data?.attributes;
}

export async function fetchOnBoardingStep5() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep5Query>({
      query: QUERY_ONBOARDING_STEP5,
    }),
  );

  return data?.step5?.data?.attributes;
}

export async function updateProfile(id: string, profile: string, gender: string, location: string, ageBracket: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUserProfileMutation>({
      mutation: MUTATION_ONBOARDING_UPDATE_USER,
      variables: {
        userId: id,
        profile,
        gender,
        location,
        ageBracket,
      },
    }),
  );
  return data;
}

export async function onCompletedOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardHomeCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onInitOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardingStartDate: new Date().toISOString().split('T')[0],
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onCompletedOnBoardingWeeklyQuestion(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER_WEEKLY,
      variables: {
        id,
        input: {
          onboardQuestionsCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}
